import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import ServiceIndex from "../../../../components/SidetabPages/Catalog/Services/ServiceIndex";

const Services = () => {
  return (
    <>
      <AnnouncementBar />
      <ServiceIndex />
    </>
  );
};
export default Services;
